// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faUsers,
  faChartLine,
  faHistory,
} from '@fortawesome/free-solid-svg-icons';
import { TableClients } from '../../scenes/clients/TableClients';
import { InfoPartner } from '../../scenes/partner/InfoPartner';
import { RecordsUserAdminPage } from '../../scenes/partner/RecordsUserAdminPage';
import NewRates from '../../scenes/rates/NewRates';
import { useTranslation } from '../../i18n/LanguageContext';

function TabsUser() {
  const { t } = useTranslation();
  const tabs = [
    { id: 'info', name: t('partnerEdit.infoTab'), icon: faUser, content: <InfoPartner /> },
    { id: 'clients', name: t('partnerEdit.clientsTab'), icon: faUsers, content: <TableClients /> },
    { id: 'commissions', name: t('partnerEdit.commissionsTab'), icon: faChartLine, content: <NewRates /> },
    { id: 'records', name: t('partnerEdit.recordsTab'), icon: faHistory, content: <RecordsUserAdminPage /> },
  ];

  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem('activeTab');
    return ['info', 'clients', 'commissions', 'records'].includes(savedTab || '') ? savedTab : 'info';
  });

  useEffect(() => {
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <div className="mt-6 w-full min-w-0 px-4 lg:px-10">
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          {t('partnerEdit.selectTab')}
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-lg border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
          value={activeTab}
          onChange={(e) => handleTabClick(e.target.value)}
        >
          {tabs.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav className="flex gap-2 rounded-2xl border border-gray-200 bg-white/80 p-1.5 shadow-sm" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`w-full rounded-xl px-3 py-3 text-center font-medium text-sm transition lg:text-base focus:outline-none focus:ring-2 focus:ring-green-cl/20 ${
                tab.id === activeTab
                  ? 'bg-green-50 font-bold text-green-cl shadow-sm ring-1 ring-green-cl/10'
                  : 'text-gray-500 hover:bg-gray-50 hover:text-gray-800'
              }`}
              onClick={() => handleTabClick(tab.id)}
            >
              <div className="flex items-center justify-center space-x-2">
                <FontAwesomeIcon icon={tab.icon} className="text-xl" />
                <span>{tab.name}</span>
              </div>
            </button>
          ))}
        </nav>
      </div>
      <div className="mt-6 w-full min-w-0 overflow-hidden">{tabs.find((tab) => tab.id === activeTab)?.content}</div>
    </div>
  );
}

export default TabsUser;
